import apiClient from './apiClient'

/**
 * Add articles to cart
 * @param {*} rowId 
 * @returns 
 */
export const fetchKitsets = async (rowId) => await apiClient.get('/api/RimKitset/' + rowId)
